import { toHijri, toGregorian } from "hijri-converter";
import { ISLAMIC_EVENTS, type IslamicEvent } from "@/data/islamicEvents";

export interface HijriDate {
  hy: number;
  hm: number;
  hd: number;
}

export function gregToHijri(date: Date): HijriDate {
  return toHijri(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

export function hijriToGreg(hy: number, hm: number, hd: number): Date {
  const { gy, gm, gd } = toGregorian(hy, hm, hd);
  return new Date(gy, gm - 1, gd);
}

export interface UpcomingEvent {
  event: IslamicEvent;
  hijriYear: number;
  date: Date;
  daysAway: number;
}

export function upcomingEvents(from: Date = new Date(), count = 6): UpcomingEvent[] {
  const today = new Date(from.getFullYear(), from.getMonth(), from.getDate());
  const startHy = gregToHijri(today).hy;
  const out: UpcomingEvent[] = [];
  for (let yOffset = 0; yOffset < 3 && out.length < count; yOffset++) {
    const hy = startHy + yOffset;
    for (const ev of ISLAMIC_EVENTS) {
      let date: Date;
      try {
        date = hijriToGreg(hy, ev.hMonth, ev.hDay);
      } catch {
        continue;
      }
      const daysAway = Math.round((date.getTime() - today.getTime()) / 86_400_000);
      if (daysAway >= 0) out.push({ event: ev, hijriYear: hy, date, daysAway });
    }
  }
  out.sort((a, b) => a.date.getTime() - b.date.getTime());
  return out.slice(0, count);
}

export function eventsForHijriYear(hy: number): UpcomingEvent[] {
  return ISLAMIC_EVENTS.map((ev) => {
    const date = hijriToGreg(hy, ev.hMonth, ev.hDay);
    const daysAway = Math.round(
      (date.getTime() - new Date().setHours(0, 0, 0, 0)) / 86_400_000,
    );
    return { event: ev, hijriYear: hy, date, daysAway };
  }).sort((a, b) => a.date.getTime() - b.date.getTime());
}

export function eventsOnGregorianDate(date: Date): UpcomingEvent[] {
  const h = gregToHijri(date);
  return ISLAMIC_EVENTS
    .filter((ev) => ev.hMonth === h.hm && ev.hDay === h.hd)
    .map((ev) => ({ event: ev, hijriYear: h.hy, date, daysAway: 0 }));
}

export const WEEKDAYS_EN = [
  "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",
];
export const WEEKDAYS_BN = [
  "রবিবার", "সোমবার", "মঙ্গলবার", "বুধবার", "বৃহস্পতিবার", "শুক্রবার", "শনিবার",
];
